import React, {useEffect} from 'react'
import './Wacha.css'
import Androidscreenshoot from '../images/Wachaimages/Androidscreenshoot.jpg'
import Artboard1 from '../images/Wachaimages/Artboard1.png'
import Artboard2 from '../images/Wachaimages/Artboard2.png'
import Artboard3 from '../images/Wachaimages/Artboard3.png'
import Artboard4 from '../images/Wachaimages/Artboard4.png'
import Artboard5 from '../images/Wachaimages/Artboard5.png'
import Artboard6 from '../images/Wachaimages/Artboard6.png'
import Artboard7 from '../images/Wachaimages/Artboard7.png'
import Artboard8 from '../images/Wachaimages/Artboard8.png'
import Artboard9 from '../images/Wachaimages/Artboard9.png'
import Artboard10 from '../images/Wachaimages/Artboard10.png'
import Artboard11 from '../images/Wachaimages/Artboard11.png'
import Artboard12 from '../images/Wachaimages/Artboard12.png'
import Artboard13 from '../images/Wachaimages/Artboard13.png'
import Artboard14 from '../images/Wachaimages/Artboard14.png'
import Artboard15 from '../images/Wachaimages/Artboard15.png'
import Footer from '../Component/footer'
function Wacha() {
    useEffect(() => {
        window.scroll(0, 0);
        document.body.scrollTop = 0;
    }, []);
    return (
        <div>
       
        <div className="imagevh" id="imageAndroidscreenshoot"><img src={Androidscreenshoot} height="" width="100%" alt=""/></div>
        
        


         <div className="imagevh" id="artboard"><img src={Artboard1} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard2} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard3} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard4} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard5} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard6} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard7} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard8} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard9} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard10} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard11} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard12} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard13} height="auto" width="100%" alt=""/></div>
        
         <div className="imagevh" id="artboard"><img src={Artboard15} height="auto" width="100%" alt=""/></div>
          <div className="imagevh" id="artboard"><img src={Artboard14} height="auto" width="100%" alt=""/></div>

          <div className="imagevh" id="artboard" ><Footer /></div> 


         
        </div>
    )
}

export default Wacha
